import type { ReactNode } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { BackButton } from "@/components/common/BackButton";
import { DASHBOARD_KINDS, type DashboardKind } from "./dashboard-kinds";
import { ProjectCreateScreen, type ProjectDraft } from "./screens/ProjectCreateScreen";

// Die Anlegen-Seite eines Projekts, für jede Art dieselbe: Zurück, Überschrift, die Maske im Kasten.
// Was angelegt wird und wohin es danach geht, entscheidet die Seite der Art (ProjectPage,
// ListingCreatePage); angelegt ist ein Objekt erst mit seinem Titel, alles Weitere kommt im Dashboard.
export function DashboardCreatePage({
  kind,
  saving,
  error,
  onCreate,
  fields,
}: {
  kind: DashboardKind;
  fields?: ReactNode;
  saving: boolean;
  /** Schon nutzertauglich übersetzt (@adr SPARK-0010-no-raw-server-errors-in-ui@1). */
  error: string | null;
  onCreate: (draft: ProjectDraft) => void;
}) {
  const intl = useIntl();
  const texts = DASHBOARD_KINDS[kind].create;
  return (
    <main className="w-full max-w-[1600px] px-4 pb-12 pt-6 @sm:px-6 @lg:px-10">
      {/* Kopf wie in der Post-Maske (ShareCreatePage): Zurück, Serifen-Überschrift. Beide Masken
          entstehen aus demselben Popup und sollen sich deshalb auch gleich anfühlen. */}
      <div className="mb-5">
        <BackButton />
      </div>
      {texts.eyebrow ? (
        <div className="mb-2 text-smycles-micro tracking-[0.25em] text-ink-muted">
          SHARE ·{" "}{/* i18n-allow: SHARE ist ein Produktname, · ein Glyph */}
          <FormattedMessage id="project.create.eyebrow" defaultMessage="Erstellen" />
        </div>
      ) : null}
      <h1 className="mb-6 font-serif text-smycles-display-m leading-tight @sm:text-smycles-display-l">
        {intl.formatMessage(texts.heading)}
      </h1>

      <div className="box max-w-[52rem] bg-surface p-6">
        <ProjectCreateScreen fields={fields} texts={texts} saving={saving} error={error} onCreate={onCreate} />
      </div>
    </main>
  );
}
